module.exports = __webpack_public_path__ + "static/media/mail.55b14315.svg";